// app/src/features/onboarding/TipsHost.jsx
import React from "react";
import { TourSpotlight } from "../../components/Panels.jsx";
import TipLayer from "../../components/TipLayer.jsx";
import { captureChatTarget } from "../../lib/forecast/chatTarget.js";
import { RAIL_W } from "../../lib/navRail.js";

/**
 * The tour spotlight and the first-contact tip layer, rendered inside `AppFrame`'s `shareDialog`
 * slot (desktop-only — the frame renders the slot on its desktop branch alone) exactly where the
 * two inline mounts sat: after the signal library overlay, before the Settings host.
 *
 * `ctx` is the frame context: the tour's state (`tourActive`, `tourSpotlight`), the eight covering
 * flags that suppress the spotlight, the rail panel's geometry for its inset, the pie-nudge
 * throttle ref with the chat line it pushes (`pushSayerMsg` at the captured target), and the tip
 * with its two handlers. The host hands `ctx` nowhere.
 */
export default function TipsHost({ ctx }) {
  const {
    tourActive,
    tourSpotlight,
    showReport,
    selEvt,
    contractOpen,
    logOpen,
    tsDrawerOpen,
    proOpen,
    accountOpen,
    bugOpen,
    railPanelOpen,
    railPanelWidth,
    pieNudgeAtRef,
    pushSayerMsg,
    getRunState,
    tip,
    dismissTip,
    turnOffTips,
  } = ctx;
  return (
    <>
      {/* Suppress the tour spotlight while any covering panel is open — its target
          (a timeline pie/trigger or an edge tab) is then occluded by the panel, and
          the fixed z600 bulb would otherwise float on top of the panel content. The
          tour's panel-open await advances regardless of the bulb being shown. */}
      {(tourActive || tourSpotlight) &&
        !(
          showReport ||
          selEvt ||
          contractOpen ||
          logOpen ||
          tsDrawerOpen ||
          proOpen ||
          accountOpen ||
          bugOpen
        ) && (
          <TourSpotlight
            target={tourSpotlight === "tab" ? null : tourSpotlight}
            chatWidth={0}
            leftInset={railPanelOpen ? RAIL_W + railPanelWidth : 0}
            onNudgeToPie={(t) => {
              const now = Date.now();
              if (now - pieNudgeAtRef.current < 4000) return;
              pieNudgeAtRef.current = now;
              pushSayerMsg(
                t === "resolution"
                  ? "Click the forecast itself to open the report."
                  : "Click the trigger's circle itself to explore it.",
                { target: captureChatTarget(getRunState()) },
              );
            }}
          />
        )}
      <TipLayer tip={tip} onDismiss={dismissTip} onTurnOff={turnOffTips} />
    </>
  );
}
